import styled, { css } from "styled-components";
import { color, units, variant } from "@m/alchemy-theme";
export const IconWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${color("base")};
  border-radius: 50%;

  ${variant("indicatorType", {
    icon: css `
      padding: ${units(1)};
      width: ${units(4)};
      height: ${units(4)};

      svg {
        color: ${color("hint")};
      }
    `,
    bullet: css `
      padding: ${units(1)};
      margin-top: 1px;

      & svg {
        display: none;
      }
    `
})};
`;
